import React, { Component } from "react";
import Translator from "components/Translator";
import Carousel from "components/Carousel";
import styles from "./style.module.scss";

const benefits = [
  {
    icon: {
      src: "icons-benefits-mac",
      alt: "people-mac-book-pro"
    },
    title: "v1_people-subtitle-5a",
    description: "v1_people-text-5a"
  },
  {
    icon: {
      src: "icons-benefits-smart",
      alt: "people-smart-working"
    },
    title: "v1_people-subtitle-5b",
    description: "v1_people-text-5b"
  },
  {
    icon: {
      src: "icons-benefits-learning",
      alt: "people-learning-resources"
    },
    title: "v1_people-subtitle-5c",
    description: "v1_people-text-5c"
  },
  {
    icon: {
      src: "icons-benefits-vouchers",
      alt: "people-meal-vouchers"
    },
    title: "v1_people-subtitle-5d",
    description: "v1_people-text-5d"
  },
  {
    icon: {
      src: "icons-benefits-stocks",
      alt: "people-stock-on-milestones"
    },
    title: "v1_people-subtitle-5e",
    description: "v1_people-text-5e"
  },
  {
    icon: {
      src: "icons-benefits-international",
      alt: "people-international-environment"
    },
    title: "v1_people-subtitle-5f",
    description: "v1_people-text-5f"
  }
];

class Benefits extends Component {
  render() {
    const benefitsListItems = benefits.map(benefit => (
      <Translator key={benefit.title}>
        {t => (
          <div>
            <img
              className={styles.benefitIcon}
              src={`/benefits/${benefit.icon.src}.svg`}
              alt={benefit.icon.src}
            />
            <h2 className="font-tt5 margin-bottom-24">{t(benefit.title)}</h2>
            <span className="font-mini-spacemono font-color-grey margin-bottom-48">
              {t(benefit.description)}
            </span>
          </div>
        )}
      </Translator>
    ));

    return (
      <div className="margin-bottom-56">
        <div className={styles.Benefits}>
          <div className="row">
            <div className="col-12 margin-bottom-48">
              <Translator>
                {t => <h2 className="font-tt3">{t("v1_people-title-5")}</h2>}
              </Translator>
            </div>

            <div className="col-12 d-none d-sm-block">
              <div className="row gutter-2 justify-content-between bottom-spacing-56">
                {benefitsListItems.map((elem, i) => (
                  <div className="col-sm-4 margin-bottom-48" key={i}>
                    {elem}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="d-block d-sm-none margin-bottom-56">
          <Carousel uniqueId="benefitsCarousel" slides={benefitsListItems} />
        </div>
      </div>
    );
  }
}

export default Benefits;



// WEBPACK FOOTER //
// ./src/components/Benefits/index.js